import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-news-desc',
  templateUrl: './news-desc.component.html',
  styleUrls: ['./news-desc.component.scss']
})
export class NewsDescComponent implements OnInit {

  descData: any;

  constructor(public dialogRef: MatDialogRef<NewsDescComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.descData = this.data;
  }

  close() {
    this.dialogRef.close();
    // window.location.reload();
  }

}
